import React from 'react';
import { useNotify } from '../../context/NotifyContext';

const ICONS = { success: '✓', error: '✕', warning: '!', info: 'i' };

export default function Notification() {
  const ctx = useNotify();
  if (!ctx) return null;
  const { toasts, dismiss } = ctx;

  return (
    <div className="toast-stack">
      {toasts.map((t) => (
        <div key={t.id} className={`toast type-${t.type}`}>
          <span className="toast-icon">{ICONS[t.type] || 'i'}</span>
          <span>{t.message}</span>
          <button className="toast-close" onClick={() => dismiss(t.id)} aria-label="close">×</button>
        </div>
      ))}
    </div>
  );
}
